import React from 'react';
import Container from 'react-bootstrap/Container';

import CheckboxList from '../../../../components/CheckboxList/CheckboxList';

import styles from '../CpInfo.module.css';

import { useTranslation } from 'react-i18next';
import { useCuttingPlanStore } from '../../../../stores/cuttingPlanStore';

const Configuration = () => {

    const { t } = useTranslation();

    const allFloors = useCuttingPlanStore(state => state.allFloors);
    const setCheckedFloors = useCuttingPlanStore(state => state.setCheckedFloors);
    const allDiameters = useCuttingPlanStore(state => state.allDiameters);
    const setCheckedDiameters = useCuttingPlanStore(state => state.setCheckedDiameters);
    const removeAllPreCutPatterns = useCuttingPlanStore(state => state.removeAllPreCutPatterns);

    return (
        <Container className='m-0 p-0' style={{ maxHeight: '675px', overflowY: 'auto' }}>
            <Container className="border shadow-sm mb-3">
                <h5 className="text-center py-3">{t("Yerleşim Planı")}</h5>
                <div className={`${styles.checkboxListContainer} mb-3`}>
                    <CheckboxList
                        items={allFloors}
                        onCheckedItemsChange={(checkedItems) => {
                            setCheckedFloors(checkedItems);
                        }}
                    />
                </div>
            </Container>
            <Container className="border shadow-sm mb-3">
                <h5 className="text-center py-3">{t("Çaplar")}</h5>
                <div className={`${styles.checkboxListContainer} mb-3`}>
                    <CheckboxList
                        items={allDiameters}
                        onCheckedItemsChange={(checkedItems) => {
                            setCheckedDiameters(checkedItems);
                        }}
                    />
                </div>
            </Container>
            <div className="d-flex justify-content-center mb-3">
                <button
                    className="btn btn-outline-danger"
                    onClick={() => {
                        removeAllPreCutPatterns();
                    }}
                >
                    {t("Tüm Hazır Kesimli Donatıları Temizle")}
                </button>
            </div>
        </Container>
    )
}

export default Configuration;